import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqPOST, reqDELETE } from '../../../Utils';

import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import Hosts from '../../../Hosts';
import { language } from './Language';
import { color } from '../../WEBContent/Color';
import { icon } from '../../WEBContent/Icon';

import * as XLSX from 'xlsx';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    // const [permissions, set_permissions] = useState({})
    const [selectedRows, setSelectedRows] = useState([]);

    const handleRowClick = (id) => {
        // document.getElementById('c_' + id)?.click();
    };

    const fetch_id_info = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
        // reqGET(`${api_crud_route}/special/${getTokenInfo().companycode}/Entidade`)
            .then(async res => {
                console.log('----->', res.data)

                let result = []
                if(Array.isArray(res.data)) {
                    for await (let el of res.data) {

                        if(parseInt(el.entity_type) === 1) {

                            if(el.numero_licenca !== undefined && el.numero_licenca !== null && el.numero_licenca !== '') {
                                el.numero_licenca_order = parseInt(el.numero_licenca).toString().padStart('5')
                            }                            
                            el.name_order = el.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                            
                            if(el.entity_profile !== undefined && el.entity_profile !== null && el.entity_profile !== '') {

                                let aux = JSON.parse(el.entity_profile)
                                // console.log('-->>', aux[0].label)

                                if(Array.isArray(aux) && aux.length > 0) {
                                    el.entity_profile = aux[0].label
                                    el.entity_profile_order = el.entity_profile.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                                }

                            }

                            // console.log('### el.clube', el.clube)
                            if(el.clube !== undefined && el.clube !== null && el.clube !== '') {

                                let aux = JSON.parse(el.clube)
                                // console.log('-->>', aux[0].name)

                                if(Array.isArray(aux) && aux.length > 0) {
                                    el.clube = aux[0].name
                                    el.clube_order = el.clube.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                                }

                            }

                            // console.log('el2', el)
                            result.push(el)

                        }

                    }
                }


                console.log('result', result)
                setData(result);
                //console.log("Dados da bd", res.data)
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await fetch_id_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: color.corPrimaria.rgb,
            cancelButtonColor: color.corVermelha.rgb,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            window.location.reload()
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const handleRowSelected = (state) => {

        setSelectedRows(state.selectedRows);
    };

    const headerStyles = {
        nome: selectedRows.length > 0 ? { backgroundColor: color.corVermelha.rgb, color: color.cor3.rgb } : {},
        idade: selectedRows.length > 0 ? { backgroundColor: color.corVermelha.rgb, color: color.cor3.rgb } : {},
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '';

        // Remove qualquer caractere não numérico
        const cleaned = phoneNumber.replace(/\D/g, '');


        if (cleaned.length < 9) return phoneNumber;


        const countryCode = cleaned.slice(0, 3); // Exemplo: 351

        const phoneNumberWithoutCode = cleaned.slice(3);


        const formattedPhone = phoneNumberWithoutCode.replace(/(\d{3})(?=\d)/g, '$1 ');


        return `+${countryCode} ${formattedPhone}`;
    };

    const columns = [
        {
            name: language[lang].numero,
            selector: 'numero_licenca_order',
            width: '12%',
            minWidth: '12% !important',
            sortable: true,
            center: true,
            cell: row => row.numero_licenca
        },
        {
            name: language[lang].name,
            selector: 'name_order',
            width: '30%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
            cell: row => row.name
        },
        {
            name: language[lang].clube,
            selector: 'clube_order',
            width: '28%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
            cell: row => row.clube
        },
        {
            name: language[lang].tipo,
            selector: 'entity_profile_order',
            width: '20%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
            cell: row => row.entity_profile
        },
        {
            name: '',
            right: true,
            export: false,
            width: '12%',
            minWidth: '110px !important',
            cell: row => (
                <span onClick={() => handleRowClick(row.id)} style={{ cursor: 'pointer' }}>
                    {/* Hidden Link for View */}
                    <Link
                        id={'c_' + row.id}
                        className="button button-update button-view p-0 pe-2"
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        replace
                    >
                        <i className={icon.view.className} style={icon.view.style}></i>
                    </Link>

                    {/* Permissions for Edit */}
                    {permissions.current !== null && (permissions.current.edit) ? (
                        <Link
                            className={permissions.current.edit ? "button button-update p-0 px-1" : "d-none"}
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                            onClick={(e) => e.stopPropagation()}
                        >
                            <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {/* Permissions for Delete */}
                    {permissions.current !== null && (permissions.current.remove) && (
                        <button
                            className="button button-delete p-0 ps-2"
                            onClick={(e) => {
                                e.stopPropagation();
                                apagar(row['id']);
                            }}
                            aria-label="Delete Ticket"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )}
                </span>
            ),
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const externalData = data.filter(entity =>
        parseInt(entity.entity_type) === 2
    );

    const internalData = data.filter(entity =>
        parseInt(entity.entity_type) === 1
    );

    const tableDataInternal = {
        columns,
        data: internalData,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const tableDataExternal = {
        columns,
        data: externalData,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    console.log("Todas as Entidades", data);

    /*
    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };    
    */



    const onChangeHandlerFilesEntities = (e) => {
        const { files, dataset } = e.target;
        const { order, langid, lang } = dataset

        let storedFiles = [];
        let filesArray = Array.prototype.slice.call(files);

        filesArray.forEach(async (v) => {
            if ((v.name.includes('.xls') || v.name.includes('.xlsx') || v.name.includes('.csv'))) {

                if (v.name.includes('.xls') || v.name.includes('.csv')) {

                    const file = v;
                    const reader = new FileReader();

                    reader.onload = async (event) => {
                        const workbook = XLSX.read(event.target.result, { type: 'binary', cellDates:true, dateNF:'dd-mm-yyyy'});
                        const sheetName = workbook.SheetNames[0];
                        const sheet = workbook.Sheets[sheetName];
                        const sheetData = XLSX.utils.sheet_to_json(sheet);

                        console.log('sheetData', sheetData);

                        await reqPOST(Hosts.SIMCore_API + '/intranet/entities/' + getTokenInfo().companycode + '/list/array', { dados: sheetData })


                    };

                    reader.readAsBinaryString(file);
                }

            }
            else {
                Swal.fire(language[lang].upload_file_error + v.name, '', 'info')
            }
        });

    }

    const conditionalRowStyles = [
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'praticante' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(25, 135, 84, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'praticante' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(25, 135, 84, 0.2)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'treinador' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(131, 161, 178, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'treinador' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(131, 161, 178, 0.2)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'seleccionador' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(253, 126, 20, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'seleccionador' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(253, 126, 20, 0.2)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'dirigente' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(13, 110, 253, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'dirigente' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(13, 110, 253, 0.2)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'director' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(220, 53, 69, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'director' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(220, 53, 69, 0.2)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'colaborador' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(111, 66, 193, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'colaborador' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(111, 66, 193, 0.2)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'outros' && row.genero !== undefined && parseInt(row.genero) === 1),
            style: {
                backgroundColor: 'rgba(108, 117, 125, 0.4)',
            },
        },
        {
        when: row => (row.entity_profile_order !== undefined && row.entity_profile_order.toLowerCase() === 'outros' && row.genero !== undefined && parseInt(row.genero) === 2),
            style: {
                backgroundColor: 'rgba(108, 117, 125, 0.2)',
            },
        },
    ];

    return (isloading ? (
        <Loader />
    ) : (
        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].entity}</h2>
                    <p>{language[lang].entity} / {language[lang].entity_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                            <div className="pb-10">
                                <div className="div-table">

                                    
                                    <div className="dropzone-panel mb-lg-0 mb-2 d-none">
                                        <div className="div-form-input col-12 custom-file">
                                            <label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-entities-0"}>{language[lang].doc_entities_choose}</label>
                                            <input 
                                                id={"input-files-entities-0"}
                                                type="file" 
                                                accept=".xls, .xlsx, .csv"
                                                data-type={'doc'}
                                                className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
                                                onChange={onChangeHandlerFilesEntities}
                                                multiple
                                            /> 
                                        </div>
                                    </div>
                                    

                                    <div className="card-header border-0 d-flex justify-content-sm-between">
                                        <h3>{language[lang].entity_interna}</h3>
                                        {permissions.current !== null && (permissions.current.create) && (
                                            <div className="table-header text-end mb-8">
                                                <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            </div>
                                        )}
                                    </div>

                                    {/*
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                    */}

                                    {/* Entidades Externas */}
                                    {/*   <div className="card mb-5 mb-xl-8">
                                        <div className="card-body">
                                            <h3 style={{ marginBottom: '2%' }}>{language[lang].entity_externa}</h3>
                                            <div className="pb-10">
                                                <div className="div-table">
                                                    <div className="table-body">
                                                        <DataTableExtensions {...tableDataExternal}>
                                                            <DataTable
                                                                noDataComponent={language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                            />
                                                        </DataTableExtensions>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* Entidades Internas */}
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="pb-10">
                                                <div className="div-table">
                                                    <div className="table-body">
                                                        <DataTableExtensions {...tableDataInternal}>
                                                            <DataTable
                                                                noDataComponent={language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                defaultSortField="name_order"
                                                                defaultSortAsc={true}
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                                conditionalRowStyles={conditionalRowStyles}
                                                                // onRowClicked={(row) => handleRowClick(row.id)}
                                                                // customStyles={{
                                                                //     rows: {
                                                                //         style: {
                                                                //             cursor: 'pointer',
                                                                //         },
                                                                //     },
                                                                // }}
                                                            />
                                                        </DataTableExtensions>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main >
    ));
}